(() => {
  const BUTTON_SELECTOR = '[data-collection-load-more]';
  const PAGINATION_SELECTOR = '[data-collection-pagination]';
  const GRID_SELECTOR = '#product-grid';

  const setBusy = (button, busy) => {
    button.disabled = busy;
    button.toggleAttribute('aria-busy', busy);
    button.textContent = busy ? 'Loading...' : 'Load more';
  };

  const sectionUrl = (rawUrl, sectionId) => {
    const url = new URL(rawUrl, window.location.origin);
    if (sectionId) url.searchParams.set('section_id', sectionId);
    return url.toString();
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.(BUTTON_SELECTOR);
    if (!button) return;
    event.preventDefault();

    const pagination = button.closest(PAGINATION_SELECTOR);
    const container = button.closest('#ProductGridContainer') || document.getElementById('ProductGridContainer');
    const grid = container?.querySelector(GRID_SELECTOR);
    const nextUrl = pagination?.dataset.nextUrl || button.dataset.nextUrl;
    const sectionId = container?.dataset.id || container?.closest('.shopify-section')?.id?.replace('shopify-section-', '');
    if (!pagination || !grid || !nextUrl || button.disabled) return;

    setBusy(button, true);
    try {
      const response = await fetch(sectionUrl(nextUrl, sectionId), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = doc.querySelector(GRID_SELECTOR);
      const nextPagination = doc.querySelector(PAGINATION_SELECTOR);
      if (!nextGrid) throw new Error('Next grid missing');

      const fragment = document.createDocumentFragment();
      const added = Array.from(nextGrid.children);
      added.forEach((item) => fragment.appendChild(item));
      grid.appendChild(fragment);

      const followingUrl = nextPagination?.dataset.nextUrl;
      if (followingUrl) {
        pagination.dataset.nextUrl = followingUrl;
        button.dataset.nextUrl = followingUrl;
        setBusy(button, false);
      } else pagination.remove();

      document.dispatchEvent(new CustomEvent('brilinton:collection-products-added', { detail: { container, grid, items: added } }));
      document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId }, bubbles: true }));
    } catch (error) {
      console.error('[Brilinton Load More]', error);
      setBusy(button, false);
    }
  });
})();
